import { RuleValidation } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { BogoSameRuleState } from './types'

export function validateBogoSameRule(rule: BogoSameRuleState): RuleValidation {
	if (!rule.products || rule.products.length === 0) {
		return { isValid: false, errors: { products: 'empty' } }
	}
	return { isValid: true, errors: {} }
}
